
import VueElementLoading from 'vue-element-loading';
import moment from 'moment';
import {getshippingidDetails} from '../../../services/ntsActions';
import {MarkNTSShipmentService, getAWBDetailsFromBag, MarkNTSBagService,ntsRoleConditoins} from '../../../services/ntsActions';
import Multiselect from 'vue-multiselect';

import { AWBNumberNormslization } from '../../../services/utility';
import { viewDisputeDetails, fetchExternalDisputeReasons,raisedDispute, getPresignedUrl,saveUploadedMedia } from '../../../services/externalDispute';
import axios from 'axios';
import apiUrl from '../../../constants';


export default {
    name: 'AddNTSShipment',
    components: {
        VueElementLoading,
        Multiselect
    },
    data() {
        return {
            awbnumber: '',
            myStr: '',
            clientId:'',
            show: false,
            shipmentType:'',
            shipmentTypeList: [{id:'DTO', label: 'DTO Shipment'}, {id:'RTO', label:'RTO Shipment'}],
            disputeReasonList:[],
            disputeReason:'',
            resonData:[],
            subReasonList:[],
            subReason: null,
            disputeSubReason:'',                // Selected sub reason
            disputeAmount:'',
            description:'',
imagePositions: [
      { key: 0, label: "Image 1" },
      { key: 1, label: "Image 2" },
      { key: 2, label: "Image 3" },
      { key: 3, label: "Image 4" },
    ],      // Uploaded file data
 uploadedImages: {},OtherProof2:'',
OtherProof1:'',
DisputeDetails:[],
// uploadedVideo: null,
responseVideoUrl:{},
 showModal: false,
      selectedFile: null,
      selectedFileName: '',
isLoading1:false,
      isimage:false,
      isvideo:false,
      username:'',
       loadingDisputeReasons: false ,
       S3key:'',
       imageUrl:{},
    loaderMessage: '', 
    actionstatuscode:null,
    videoTypes: [
      { key: 'unboxing', label: 'Shipment Unboxing' },
      { key: 'packaging', label: 'Packaging Video' }
    ],
    uploadedVideo: {},
    s3Keys: {},
    shippingid : '',
    currentclientconfig : {},

       // if loading from API

        }
    },
    mounted() {
        var userToken = window.localStorage.getItem('accessuserToken');
        this.myStr = userToken.replace(/"/g, '');
        this.username = window.localStorage.getItem('username');
        this.awbnumber = this.$route.query.awb;
        this.shippingid = this.awbnumber;
        this.clientId = this.$route.query.clientId  
        this.actionstatuscode =  this.$route.query.actionstatuscode  
        this.pageName = this.$route.query.pageName ? String(this.$route.query.pageName): '';        
                      
        this.viewDisputeDetails()
     
    },
    watch: {
    shipmentType(newVal) {
      if (newVal && newVal.label) {
        this.fetchDisputeReasons(newVal);
      }
    }
  },
    methods: {
    async saveData() {   
      const expectedKeys = ['0', '1', '2', '3'];
const isImageInvalid = this.isimage && (
  this.uploadedImages == null ||
  expectedKeys.some(key => {
    const img = this.uploadedImages[key];
    return img == null || (typeof img === 'string' && img.trim() === '');
  })
);
const hasAtLeastOneVideo =
  this.uploadedVideo &&
  Object.values(this.uploadedVideo).some(
    v => v !== null && v !== undefined && String(v).trim() !== ''
  );
const isVideoInvalid = this.isvideo && !hasAtLeastOneVideo;
      
  this.imageUrl=this.uploadedImages  
  const fieldMapping = {
  0: "PhotoProof1_Front",
  1: "PhotoProof2_Back",
  2: "PhotoProof3_RightSide",
  3: "PhotoProof4_LeftSide"
};
const remapped = {};
for (const key in fieldMapping) {
  const fieldName = fieldMapping[key];
  remapped[fieldName] = this.imageUrl[key] || null;
}

this.imageUrl = remapped;  
  let input = {
  Clientid: this.clientId,
  AWBNumber: this.awbnumber,
  ShipmentType:this.shipmentType.id ,
  DisputeReasonCode: "1001",
  DisputeAmount: this.disputeAmount ? this.disputeAmount.toString():null,
  DisputeReason: this.disputeReason.label,
  DisputeSubReason: this.disputeSubReason.label,
  Comments: this.description? this.description : null,
  DisputeProdcutImageURL: [this.imageUrl],
  DisputeProductVideoURL: [
    {
      UnboxingVideoProof1: this.responseVideoUrl && this.responseVideoUrl.unboxing
        ? this.responseVideoUrl.unboxing
        : null,

      PackagingVideoProof1: this.responseVideoUrl && this.responseVideoUrl.packaging
        ? this.responseVideoUrl.packaging
        : null
    }
  ],
  SourceType: "ClientAPI",
  OtherProofs1: this.OtherProof1 ? this.OtherProof1:"",
  OtherProofs2: this.OtherProof2 ? this.OtherProof2:"",
  createdBy: this.username,
  DisputeSourceType: "Investigation Portal",
  DisputeLogEvent: "Dispute raised by Internal User"
} 
if (isImageInvalid || isVideoInvalid || !this.isFormValid) {
  input.actionStatus = "Draft";
} else {
  input.actionStatus = "Open";
}


  try {
   raisedDispute(input, this.myStr)
  .then(response => {
    const returnCode = response.data.ReturnCode;
    const returnMessage = response.data.ReturnMessage || "No message returned";

    if (returnCode !== 100) {
      this.$alertify.error(returnMessage);  // Show error if code not 100
    } else {
      this.$alertify.success(returnMessage);
      if(this.pageName == "CLT")this.$router.push({ path: '/AddEditRaiseDEPSLoggedByCLT' });
      else this.$router.push({ path: '/logSingleDispute' });
        // Show error if code not 100
    }
  })
  } catch (error) {
    console.error("Failed to raise dispute", error);
  }
},


    base64ToBlob(base64, contentType = 'image/png') {
      const byteCharacters = atob(base64.split(',')[1]);
      const byteArrays = [];

      for (let i = 0; i < byteCharacters.length; i += 512) {
        const slice = byteCharacters.slice(i, i + 512);
        const byteNumbers = new Array(slice.length);

        for (let j = 0; j < slice.length; j++) {
          byteNumbers[j] = slice.charCodeAt(j);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      return new Blob(byteArrays, { type: contentType });
    },

    async uploadImage(formData) {
    const response = await axios({
          method: 'post',
          url: `${apiUrl.api_url}uploadvedioImages`,
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + this.myStr
          },
        });
        return response
    },
  triggerImageInput(key) {
const inputRef = this.$refs['imageInput_' + key];
  if (Array.isArray(inputRef)) {
    inputRef[0].click(); // First element in the array
  } else if (inputRef) {
    inputRef.click(); // In case it's not in v-for and returns single element
  }            },
    Backinvestigation() {
      if(this.pageName == "CLT")this.$router.push({ path: '/AddEditRaiseDEPSLoggedByCLT' });
      else this.$router.push({ path: '/logSingleDispute' });
    }, 
 handleImageUpload(event, key) {
  const file = event.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = async e => {
      this.$set(this.uploadedImages, key, e.target.result);
      // ✅ Call uploadAllImages after image is loaded
      await this.uploadAllImages();
    };

    reader.readAsDataURL(file);
  }
},
    removeImage(key) {
      this.uploadedImages[key] = null;
    },
    triggerVideoInput(type) {
      this.$refs[`videoInput_${type}`][0].click()
    },
    async handleVideoUpload(event, videotype) {
      this.isLoading1 = true;
      this.loaderMessage ='While the video is being uploaded, please do not close or reload the webpage';
    
      const file = event && event.target && event.target.files && event.target.files[0];
      if (!file) {
        this.isLoading1 = false;
        this.$alertify.error("No file found to upload.");
        return;
      }
    
      const input = {
        shippingid: this.awbnumber,
        fileName: file.name,
        type: "video",
        contentType: file.type,
      };
    
      try {
        /* 1️⃣ Get presigned URL */
        let reasons;
        try {
          reasons = await getPresignedUrl(input, this.myStr);
        } catch (error){
          this.isLoading1 = false;
          this.$alertify.error("Failed to get upload URL from server.");
          return;
        }
    
        const presignedWrap = reasons && reasons.data ? reasons.data : reasons;
      
      const presigned = presignedWrap && presignedWrap.ReturnResult ? presignedWrap.ReturnResult: presignedWrap;
    
        if (!presigned || !presigned.uploadUrl || !presigned.key) {
          this.isLoading1 = false;
          this.$alertify.error("Upload URL not returned correctly by server.");
          return;
        }
    
        /* 2️⃣ Upload to S3 */
        try {
          const resp = await axios.put(presigned.uploadUrl, file, {
            headers: { "Content-Type": file.type }
          });
    
          if (![200, 201, 204].includes(resp.status)) {
            throw new Error("Invalid S3 response");
          }
        } catch (error){
          this.isLoading1 = false;
          this.$alertify.error("Failed to upload file to storage.");
          return;
        }
    
        /* 3️⃣ Save key & notify backend */
        this.s3Keys[videotype] = presigned.key;
        await this.uploadVideo(videotype);
    
        /* 4️⃣ Preview */
        
        this.$alertify.success("Video uploaded successfully.");
    
      } catch (err) {
        console.error(err);
        this.$alertify.error("Video upload failed. Please try again.");
      } finally {
        this.isLoading1 = false;
        this.loaderMessage = '';
      }
    },


    removeVideo(type) {
      this.$delete(this.uploadedVideo, type);
      this.$delete(this.s3Keys, type);
      this.$delete(this.responseVideoUrl, type);

    },
    async uploadVideo(type) {
      const s3Key = this.s3Keys[type];
      if (!s3Key) {
        this.$alertify.error("Please select a video");
        return;
      }
    
      const input = {
        s3Key,
        shippingid: this.awbnumber,
        type: "video",
        uploaderId: this.username
      };

      try {
        const reasons = await saveUploadedMedia(input, this.myStr);
        const response = reasons && reasons.data && reasons.data.ReturnResult ? reasons.data.ReturnResult : null;
      if (response && response.tempMediaId) {
        this.responseVideoUrl[type] = response.tempMediaId;
        this.$set(this.uploadedVideo, type, response.tinyURL);
      }
        this.$alertify.success("Video uploaded successfully");
      } catch (error) {
        console.error("Error uploading video:", error);
        this.$alertify.error("Failed to upload video. Please try again.");
      } finally {
        this.isLoading1 = false;
        this.loaderMessage = ''
      }
    },

    async fetchDisputeReasons(shipmentType) {
      
  let input = {
    taskType: shipmentType.id,
    disputeRaisedType: "Client"
  };
   
  return fetchExternalDisputeReasons(input, this.myStr).then(reasons => {
    this.reasonData = reasons.data.ReturnResult; // 🔁 FIXED: changed from resonData to reasonData

    this.disputeReasonList = this.reasonData.map((reason, i) => ({
      id: i,
      label: reason.reason
    }));
  });
},

async uploadAllImages() {
  // 🔄 Show loader once before all uploads
  this.isLoading1 = true;
  this.loaderMessage = 'While image is being uploaded, please do not close or reload the webpage';

  try {
    for (const key in this.uploadedImages) {
      const base64 = this.uploadedImages[key];

      if (
        typeof base64 !== "string" ||
        !base64.includes("base64,") ||
        base64.length < 100
      ) {
        continue;
      }
      // Update loader message for current image
      this.loaderMessage = 'While image is being uploaded, please do not close or reload the webpage';
      const match = base64.match(/^data:([^;]+);base64,/);
      const contentType = match ? match[1] : '';
      const blob = this.base64ToBlob(base64, contentType);
      const fileName = `image_${parseInt(key)}.png`;

      const formData = new FormData();
      formData.append("file", blob, fileName);
      formData.append("shippingid", this.awbnumber);

      const response = await this.uploadImage(formData);

      const uploadedUrl = response && response.data && response.data.ReturnResult && response.data.ReturnResult.tinyURL ? response.data.ReturnResult.tinyURL : null;

      if (uploadedUrl) {
        this.uploadedImages[key] = uploadedUrl;
        this.$alertify.success(`Image ${fileName} uploaded successfully`);
      }
    }
  } catch (error) {
    this.$alertify.error("Image upload failed. Please try again.");
  } finally {
    // ✅ Hide loader after all uploads are done
    this.isLoading1 = false;
    this.loaderMessage = '';
  }
},

async viewDisputeDetails() {
  let input = {
    awbNo:this.awbnumber,
    Clientid:this.clientId,
    userType:"Internal"
  };
  const details = await viewDisputeDetails(input, this.myStr);
  const result = details && details.data && details.data.ReturnResult ? details.data.ReturnResult : {};

  const disputeDetails = result.DisputeDetails || {};
  const shipmentDetails = result.ShimentDetails || {};
  const clientConfig = result.clientConfig || {};
  const clientImages = result.clientImages || {};
  const clientVideo = result.clientVideo || {};
  // this.responseVideoUrl = clientVideo;
  this.responseVideoUrl = {};

  // Store full result
  this.DisputeDetails = details && details.data ? details.data : {};

  // ✅ Safely extract values
  const reason = disputeDetails.Reason || null;
  const subreason = disputeDetails.SubReason || null;
  const shipmentType = shipmentDetails.shipmentType || null;

  this.disputeAmount = disputeDetails.DisputeAmount || null;
  this.description = shipmentDetails.Comments || '';
  this.isimage = typeof clientConfig.isimage !== 'undefined' ? clientConfig.isimage : false;
  this.isvideo = typeof clientConfig.isvideo !== 'undefined' ? clientConfig.isvideo : false;
      this.currentclientconfig = clientConfig;
      if (reason && subreason) {
        let input = {
          id: shipmentType.toLowerCase() == 'rto shipment' ? 'RTO' : 'DTO'
        }
        await this.fetchDisputeReasons(input);
        this.buildimagevidconfig(reason, subreason);
      }
  this.OtherProof1 = shipmentDetails.OtherProofs1 || '';
  this.OtherProof2 = shipmentDetails.OtherProofs2 || '';

  // ✅ Video
  // this.uploadedVideo = clientVideo;
  this.uploadedVideo = {};
  const videoKeyMap = {
    UnboxingVideoProof1: 'unboxing',
    PackagingVideoProof1: 'packaging'
  };
  Object.entries(videoKeyMap).forEach(([backendKey, type]) => {
    const value = clientVideo && clientVideo[backendKey];
    if (value !== null && value !== undefined && String(value).trim() !== '') {
      this.responseVideoUrl[type] = value;
      this.uploadedVideo[type] = value; // edit/preview mode
    }
  });
  

  // ✅ Images
  Object.keys(clientImages).forEach((key, index) => {
    const imageUrl = clientImages[key];
    if (imageUrl) {
      this.$set(this.uploadedImages, index, imageUrl);
    }
  });
   
  // ✅ Shipment type (Multiselect)
  this.shipmentType = shipmentType ? this.shipmentTypeList.find(item => item.label === shipmentType) || { label: shipmentType }: null;

  // ✅ Dispute Reason
  this.disputeReason = reason ? this.disputeReasonList.find(item => item.label === reason) || { label: reason } : null;

  // ✅ Dispute SubReason
  this.disputeSubReason = subreason ? this.subReasonList.find(item => item.label === subreason) || { label: subreason } : null;
     
},


    onDisputeReasonChange(selected) {
      if (selected && selected.label) {
        const match = this.reasonData.find(item => item.reason === selected.label); // 🔁 FIXED here too
        this.subReasonList = match && match.subReason
          ? match.subReason.map(sub => ({
            label: sub.subReason,
          }))
          : [];
        this.disputeSubReason = null; // Reset previously selected subReason
      }
    },
    onDisputeSubReasonChange(){
      if (this.disputeReason && this.disputeSubReason) {
        this.buildimagevidconfig(this.disputeReason.label,this.disputeSubReason.label);
      }
    },
    buildimagevidconfig(reason,subreason){
      const reasonObj = this.reasonData.find(r => r.reason === reason);
      if (reasonObj) {
        const subReasonObj = reasonObj.subReason.find(s => s.subReason === subreason);
        if (subReasonObj) {
          const { isimage, isvideo } = subReasonObj;
          if (isimage == false && isvideo == false) {
            this.isimage = isimage;
            this.isvideo = isvideo;
          }else if (this.currentclientconfig && this.currentclientconfig.isimage != null && this.currentclientconfig.isvideo !=null){
            this.isimage = this.currentclientconfig.isimage;
            this.isvideo = this.currentclientconfig.isvideo
          }else{
            this.isimage = isimage;
            this.isvideo = isvideo;
          }
        }
      }
    }
  },
    computed: {
      isFormValid() {
        const isVideoInvalid =
          this.isvideo && (!this.uploadedVideo || Object.keys(this.uploadedVideo).length === 0 ||
            Object.values(this.uploadedVideo).every(
              v => v == null || (typeof v === 'string' && v.trim() === '')
            )
          );
        const expectedKeys = ['0', '1', '2', '3'];
        const isImageInvalid = this.isimage && (this.uploadedImages == null || expectedKeys.some(key => {
          const img = this.uploadedImages[key];
          return img == null || (typeof img === 'string' && img.trim() === '');
        })
        );

        return (
          !isVideoInvalid &&
          !isImageInvalid &&
          this.shipmentType &&
          this.disputeReason &&
          this.disputeSubReason
        );
      }

}

}



// WEBPACK FOOTER //
// ./src/views/components/EditSingleDispute/EditSingleDispute.component.js